<template>
  <div style="margin-top:20px;width: 100%;"
       class="flexCenter">
    <div class="highlights_item"
         :style="{'flex':index == activeIndex?'2':'1','backgroundPosition':'50%','backgroundSize':index != activeIndex?'cover':'100% 100%' ,'backgroundRepeat': 'no-repeat'}"
         @mouseenter="mouseover(index)"
         v-for="(item,index) in list"
         :key="index">
      <!-- 'backgroundImage':'url(' + item.url + ')' -->
      <div v-if="index!= activeIndex"
           class="hide">
        <div class="title font16">{{item.title}}</div>
        <div class="content font12"
             v-for="(x,y) in item.list"
             :key="y">{{x}}</div>

        <img :src="$imgUrl + item.url"
             alt="">
      </div>
      <div class="show"
           v-else>
        <div class="title font24"
             :style="{'backgroundImage':'url('+$imgUrl+'OnlineBusinessSchool/CJ_img.png)','backgroundSize':'100% 100%','backgroundRepeat': 'no-repeat'}">{{item.title}}</div>
        <div class="content font16"
             v-for="(x,y) in item.list"
             :key="y">{{x}}</div>

        <div class="flexCenter"
             style="width:100%;position: absolute;bottom: 40px;left: 0;">
          <img :src="$imgUrl + item.url"
               alt="">
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data () {
    return {
      activeIndex: 0,
      list: [
        { url: 'OnlineBusinessSchool/zj.png', title: '搭建专属商学院', list: ['海量组件一键用', '申请账号，录入员工'] },
        { url: 'OnlineBusinessSchool/cd.png', title: '培训数据存档', list: ['线下评比、技能大赛', '团队进阶、员工技能'] },
        { url: 'OnlineBusinessSchool/400.png', title: '400+零售体系课', list: ['营采鲜销课程体系', '课程配套内容完善', '每周上新1-2期', '课程体系内容全面', '企业一键采购内部'] },
        { url: 'OnlineBusinessSchool/cp.png', title: '测评系统', list: ['每期课程配套考试', '检测员工学习效果', '助力企业培训落地', '比学赶帮超学习文化', '岗位晋升考核'] },
        { url: 'OnlineBusinessSchool/jh.png', title: '培训计划指派', list: ['按岗位、技能划分', '培训计划指向性', '提高培训效率'] },
        { url: 'OnlineBusinessSchool/fx.png', title: '培训数据分析系统', list: ['数据分析、赋能经验', '学习统计，岗位划分', '找出问题、提升方向', '效率倍增、培训拓展'] },
      ]
    }
  },
  methods: {
    mouseover (e) {
      console.log(e)
      this.activeIndex = e
    },
    mouseout (e) {
      console.log('mouseout' + e)
    }
  }
}
</script>
<style lang="less" scoped>
// .active {
//   flex: 2;
//   margin-right: 20px;
//   border-radius: 20px;
//   background-color: #fff;
//   height: 400px;
// }
.highlights_item {
  // flex: 1;
  // margin-right: 20px;
  border: 1px solid #cccccc;
  border-radius: 10px;
  // padding: 20px;
  box-sizing: border-box;
  background-color: #fff;
  height: 400px;
  transition: all 0.3s ease-in-out;
  position: relative;
  .hide {
    width: 100%;
    height: 100%;
    padding: 70px 20px 0 20px;
    border-radius: 10px;
    box-sizing: border-box;
    background: #f6f6f6;
    color: #fff;
    // display: flex;
    // align-items: center;
    text-align: center;
    // justify-content: center;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    position: relative;
    .title {
      color: #333;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .content {
      color: #666666;
      margin-bottom: 6px;
    }
    img {
      position: absolute;
      bottom: 54px;
      left: 12px;
      width: 146px;
      height: 86px;
    }
  }
  .show {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #fff6f6;
    border-radius: 10px;
    // padding: 30px;
    box-sizing: border-box;
    color: #333333;
    text-align: center;
    .title {
      width: 100%;
      // border-radius: 10px 10px 0 0;
      height: 60px;
      color: #ffffff;
      line-height: 60px;
      text-align: center;
      margin-bottom: 30px;
    }
    .content {
      color: #333333;
      margin-bottom: 8px;
    }
    img {
      width: 200px;
      height: 118px;
    }
  }
}
.highlights_item:nth-child(5) {
  margin-right: 0;
}
</style>